export const OPEN_SHIFT = "OPEN_SHIFT";
export const CLOSE_SHIFT = "CLOSE_SHIFT";
export const NEW_USER = "NEW_USER";
export const NEW_RENT = "NEW_RENT";
export const RETURNED_RENTS = "RETURNED_RENTS";
